import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import React from 'react';
import OptimizedVariantSelect from './OptimizedVariantSelect';

// Base: right-side content (label ~20px + input ~40px + button ~32px) + 24px padding = 116px
// Each tag row: ~28px tall, ~2 tags fit per row in the 230px combo column
const BASE_ROW_HEIGHT = 116;
const TAG_ROW_HEIGHT = 28;
const TAGS_PER_ROW = 1; // variant labels are long, only 1 fits per row in the 230px column
const COMBO_LABEL_HEIGHT = 22; // "Select variants" label above the combo

const getItemHeight = (item, itemVariantsMap) => {
    const variantCount =
        item.variant_option_ids?.length ||
        (Array.isArray(item.variant_option_id) ? item.variant_option_id.length : 0) ||
        0;
    const tagRows = variantCount > 0 ? Math.ceil(variantCount / TAGS_PER_ROW) : 1;
    return Math.max(BASE_ROW_HEIGHT, COMBO_LABEL_HEIGHT + tagRows * TAG_ROW_HEIGHT + 40 + 24);
};

const VirtualizedItemList = ({
    items,
    itemVariantsMap,
    errors,
    control,
    isLoadingItems,
    getSelectedVariantOptions,
    handleVariantChange,
    deleteSpecificRequiredItems,
}) => {
    const itemSize = (index) => getItemHeight(items[index], itemVariantsMap);

    const Row = ({ index, style }) => {
        const item = items[index];
        return (
            <div style={{ ...style, borderBottom: '1px solid #D3DAE6', padding: '12px 0' }}>
                <OptimizedVariantSelect
                    item={item}
                    index={index}
                    itemVariantsMap={itemVariantsMap}
                    errors={errors}
                    control={control}
                    isLoadingItems={isLoadingItems}
                    getSelectedVariantOptions={getSelectedVariantOptions}
                    handleVariantChange={handleVariantChange}
                    deleteSpecificRequiredItems={deleteSpecificRequiredItems}
                />
            </div>
        );
    };

    const totalHeight = items.reduce((sum, item) => sum + getItemHeight(item, itemVariantsMap), 0);
    const listHeight = Math.min(totalHeight, 500);

    return (
        <div style={{ height: listHeight, width: '100%' }}>
            <AutoSizer disableHeight>
                {({ width }) => (
                    <List
                        height={listHeight}
                        itemCount={items.length}
                        itemSize={itemSize}
                        width={width}
                    >
                        {Row}
                    </List>
                )}
            </AutoSizer>
        </div>
    );
};

export default React.memo(VirtualizedItemList);
